import { useMemo } from 'react'

import { useBookkeepingBankAccounts } from './useBookkeepingBankAccounts'

export const useActiveBookkeepingBankAccount = () => {
  const { bookkeepingBankAccounts } = useBookkeepingBankAccounts()

  const activeBookkeepingBankAccount = useMemo(
    () => bookkeepingBankAccounts.find(({ isBankAccount, isArchived }) => isBankAccount && !isArchived),
    [bookkeepingBankAccounts],
  )

  return { activeBookkeepingBankAccount }
}
